export const LANG = {
  EN: 'en-ca',
  FR: 'fr-ca'
}
